export default __webpack_public_path__ + "static/media/menu--coupon.d6184531.jpg";